import { render, staticRenderFns } from "./SchemesDiscountDetails.vue?vue&type=template&id=483853b4&scoped=true"
import script from "./SchemesDiscountDetails.vue?vue&type=script&lang=ts"
export * from "./SchemesDiscountDetails.vue?vue&type=script&lang=ts"
import style0 from "./SchemesDiscountDetails.vue?vue&type=style&index=0&id=483853b4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483853b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/CONA-CRM/Admin/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('483853b4')) {
      api.createRecord('483853b4', component.options)
    } else {
      api.reload('483853b4', component.options)
    }
    module.hot.accept("./SchemesDiscountDetails.vue?vue&type=template&id=483853b4&scoped=true", function () {
      api.rerender('483853b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/schemes-discounts/components/SchemesDiscountDetails.vue"
export default component.exports